import type { App, Directive } from 'vue'

export function createCore(options?: any) {
  return {
    install(app: App) {
      console.debug('%ccreateCore()', 'color:green', $version)
      // app.component('v-img', vImg)
      // app.directive('url', <Directive<HTMLElement,string>>{
      //   mounted(el, binding, vnode) {
      //     console.log('xxxxxxx', )
      //   },
      // })
    },
  }
}
